
export const environment = {
  production: true,
  environment: 'UAT',
  birdeye_url:'https://api.birdeye.com',
  birdeye_business_id:'163295411066298',
  birdeye_api_key:'e38mpcbVN3AHx4QO6qgnzkHI9PcphWts',
  api_url:'https://api-use-d365ce-digital-uat.azurewebsites.net',
  google_api_key:'AIzaSyBs6zPqxv4f58PWZltA63o9LaD8d1T2dFA',
  app_insights_instrumentation_key:'289f3c8b-f191-4fdb-9f3d-9e65821bf9bf',
};
